export default {
  multiple: 'Перетащите или выберите файлы',
  single: 'Перетащите или выберите файл',
};
